import styles from "./Page16.module.css";

const Page16 = () => {
  return (
    <main className={styles.main}>
      <div className={styles.wrapper}>
        <h1 className={styles.title}>Signature Programme & Zugang</h1>
        <div className={styles.textWrapper}>
          <div className={styles.leftTextWrapper}>
            <div className={styles.paragraphWrapper}>
              <h3 className={styles.liTitle}>Exklusivitäts-Standard</h3>
              <p className={styles.text}>
                Re-Aging sind Premium-Programme für Menschen mit höchsten
                Ansprüchen. Die Teilnahme erfolgt ausschließlich nach einem
                persönlichen Vorgespräch und sorgfältiger Auswahl, um eine
                harmonische Gruppendynamik und ein optimales Ergebnis
                sicherzustellen.
              </p>
            </div>
            <div className={styles.paragraphWrapper}>
              <h3 className={styles.liTitle}>Exklusivitäts-Standard</h3>
              <p className={styles.text}>
                Kleingruppen mit 4–5 Teilnehmer:innen – individuell abgestimmt,
                harmonisch zusammengestellt. VIP-Programme 1:1, Paar – für
                höchste Diskretion und Flexibilität. Private Home Visits.
              </p>
            </div>
          </div>
          <div className={styles.rightTextWrapper}>
            <div className={styles.paragraphWrapper}>
              <h3 className={styles.liTitle}>Hinweis</h3>
              <p className={styles.text}>
                Alle Re-Aging Gruppen- und Metabolik- Programme für 2026 sind
                vollständig ausgebucht. Auf Wunsch nehmen wir Sie auf die
                priorisierte Warteliste und laden Sie zu einem Vorgespräch ein –
                vor Ort, online oder als Home Visit.
              </p>
            </div>
            <div className={styles.paragraphWrapper}>
              <h3 className={styles.liTitle}>
                VIP-Programme & individuelle Betreuung
              </h3>
              <p className={styles.text}>
                Für Klientinnen, die eine schnellere Terminvergabe, maximale
                Individualisierung und absolute Diskretion wünschen, stehen
                unsere VIP-Programme zur Verfügung. Diese Leistungen werden nur
                in limitierter Anzahl vergeben – bitte nehmen Sie bei Interesse
                direkt Kontakt mit uns auf.
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Page16;
